// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 0,
  pageSize: 20,
  customFilters: [],
  value: "",
  sorting: [],
  sortField: "nom",
  sortOrder: "asc",
  activeTab: "details",
  //Nouveau
  query: "",
  actif: {},
  selectedOptionFilters: null,
  selectedOptionId: null,
  column: [],
};

const FiltreReservations = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_RESERVATION:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_RESERVATION:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_CUSTOM_FILTERS_RESERVATION:
      return {
        ...state,
        customFilters: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_RESERVATION:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_PAGE_SIZE_RESERVATION:
      return {
        ...state,
        pageSize: action.payload,
      };
    case actionTypes.SET_SORTING_RESERVATION:
      return {
        ...state,
        sorting: action.payload,
      };
    case actionTypes.SET_ORDER_RESERVATION:
      return {
        ...state,
        sortOrder: action.payload,
      };
    case actionTypes.SET_ACTIVE_TAB_RESERVATION:
      return {
        ...state,
        activeTab: action.payload,
      };
    case actionTypes.SET_QUERY_RESERVATION:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.SET_ACTIF_RESERVATION:
      return {
        ...state,
        actif: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_FILTERS_RESERVATION:
      return {
        ...state,
        selectedOptionFilters: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_ID_RESERVATION:
      return {
        ...state,
        selectedOptionId: action.payload,
      };
    case actionTypes.SET_COLUMN_RESERVATION:
      return {
        ...state,
        column: action.payload,
      };
    default:
      return state;
  }
};

export default FiltreReservations;
